export default function authPluginFactory( authService ) {
	return {
		install( Vue ) {
			Vue.prototype.$auth = authService;

			Vue.mixin( {
				created() {
					if ( this.handleLoginEvent ) {
						authService.addListener( "loginEvent", this.handleLoginEvent );
					}
				},

				destroyed() {
					if ( this.handleLoginEvent ) {
						authService.removeListener( "loginEvent", this.handleLoginEvent );
					}
				},
			} );
		},
	};
}



// WEBPACK FOOTER //
// ./src/helpers/authPlugin.js